import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const MCare = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';
  
  useEffect(() => {
    try {
      console.log('Redirecting to /redirect');
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      console.error('Error during redirect:', err);
      if (typeof console !== 'undefined') console.log(err);
    }
    
    const queryParams = new URLSearchParams(location.search);
    const caeQMemID = queryParams.get('memqnxtid');
    const systemId = queryParams.get('SystemId');
    const userId = queryParams.get('UserId');
    const Module = queryParams.get('Module') || '';
   
    
    fetchMCareURL(caeQMemID, systemId, userId, Module);
  }, [location]);
  
  const fetchMCareURL = async (caeQMemID, systemId, userId, Module) => {

    console.log('Request parameters:', { caeQMemID, systemId, userId, Module });

    try {
      const response = await axios.get(`${API_URL}/api/MCare/GetMCareUrl`, {
        params: {
          caeQMemID: caeQMemID || '',
          systemId: systemId || '',
          userId: userId || '',
          Module: Module || 'MCare'
        }
      });

      console.log('API Response:', response.data);
      
      setLoading(false);
      
      // Use direct navigation instead of form submission
      if (response.data && response.data.url) {
        console.log('Redirecting to URL:', response.data.url);
        window.location.href = response.data.url;
      } else {
        console.error('No URL found in response');
        setError('mcare');
      }
    } catch (error) {
      console.error('Error fetching MCare URL:', error);
      setError('mcare');
      setLoading(false);
    }
  };

  return (
    <div>
      <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0" align="center">
        <tbody>
          <tr align="center">
            <td align="center" style={{fontSize: 'large'}}>
              {loading && (
                <img src={LoadingImage} id="loadinggif" style={{alignContent: 'center'}} alt="Loading" />
              )}
            </td>
            <td>
              {loading && <div id="loadingtext">Loading...</div>}
            </td>
          </tr>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center" style={{fontSize: 'x-large'}}>
              {error && <ErrorPage errorType="mcare" />}
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MCare;